'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  gameWidth: 64,
  gameHeight: 64,
  localStorageName: 'bullboat',
  world: {
    gravity: 300
  },
  player: {
    accel: 20,
    deaccel: 15,
    targetSpeed: 23,
    initialSpeed: 5,
    lives: 4
  },
  camera: {
    x: 32.0,
    y: 96.0,
    z: 0.0,
    depth: 0.5
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 46
// module chunks = 0